module.exports = __webpack_public_path__ + "static/img/原料泡泡-2.186d3428.png";